<template>
  <div></div>
</template>
<script>
import { ElMessage } from 'element-plus'

import { tokenStorage } from '../api/api-client/TokenStorage'

export default {
  name: 'AutoLogout',
  data: function () {
    return {
      events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
      logoutTimer: null,
      warningZone: false,
      minutes: 960, // 16 hours in minutes
      excludeRoutes: [
        'loginform',
        'otp',
        'forgotpassword',
        'magic-email',
        'magic-login',
        'passwordreset',
        'passwordcreate',
        '503',
      ],
    }
  },
  watch: {
    // Watch for route changes to start/stop timer appropriately
    $route() {
      this.initializeTimer()
    },
  },
  mounted() {
    // Set up event listeners
    this.events.forEach((event) => {
      window.addEventListener(event, this.resetTimer)
    })

    // Only start timer if not on excluded route
    this.initializeTimer()
  },
  unmounted() {
    // Use arrow function to preserve 'this' context
    this.events.forEach((event) => {
      window.removeEventListener(event, this.resetTimer)
    })
    // Clear the timer
    this.clearTimer()
  },
  methods: {
    // Checking if AutoLogout should be active
    shouldBeActive() {
      const currentRoute = this.$route?.name
      const isExcluded = this.excludeRoutes.includes(currentRoute)
      return !isExcluded
    },
    initializeTimer() {
      if (this.shouldBeActive()) {
        this.setTimers()
      } else {
        this.clearTimer()
      }
    },
    setTimers: function () {
      // Clear any existing timer first
      this.clearTimer()

      // Skipping timer setup - user on excluded route
      if (!this.shouldBeActive()) {
        return
      }

      const time = this.minutes * 60 * 1000 //  minutes in milliseconds.
      const warningTime = time - 5 * 60 * 1000 // Show warning 5 minutes before logout

      // Set warning timer
      this.warningTimer = setTimeout(() => {
        this.showWarning()
      }, warningTime)

      this.logoutTimer = setTimeout(this.logoutUser, time)
      this.warningZone = false
    },
    clearTimer() {
      if (this.logoutTimer) {
        clearTimeout(this.logoutTimer)
        this.logoutTimer = null
      }
      if (this.warningTimer) {
        clearTimeout(this.warningTimer)
        this.warningTimer = null
      }
    },

    showWarning() {
      ElMessage.warning({
        message: 'Your session will expire in 5 minutes due to inactivity. Move your mouse or click to stay logged in.',
        duration: 10000, // 10 seconds
        showClose: true,
      })
      this.warningZone = true
    },
    logoutUser: function () {
      if (this.shouldBeActive()) {
        console.log('Auto-logout triggered after', this.minutes, 'minutes of inactivity')

        // Convert minutes to hours for better readability
        const hours = Math.floor(this.minutes / 60)
        const remainingMinutes = this.minutes % 60
        let timeText = ''

        if (hours > 0 && remainingMinutes > 0) {
          timeText = `${hours} hours and ${remainingMinutes} minutes`
        } else if (hours > 0) {
          timeText = `${hours} hours`
        } else {
          timeText = `${this.minutes} minutes`
        }

        ElMessage.error(
          `Oops, you have been In-Active for the last ${timeText}. Session expired. Redirecting to Login.`
        )
        setTimeout(() => {
          localStorage.clear()
          tokenStorage.setByKey('otp_verified', false)
          window.location.href = '/logout'
        }, 7000)
      }
    },
    resetTimer: function () {
      // Only reset timer if we should be active
      if (!this.shouldBeActive()) {
        return
      }
      //  if user activity detected, reset timer.
      this.setTimers()
    },
    // Debug method to check timer status - call from browser console: window.$autoLogout.getTimerStatus()
    getTimerStatus() {
      return {
        timerActive: !!this.logoutTimer,
        timeoutMinutes: this.minutes,
        warningZone: this.warningZone,
        currentRoute: this.$route?.name,
        shouldBeActive: this.shouldBeActive(),
        excludedRoutes: this.excludeRoutes,
        eventsListening: this.events,
      }
    },
  },
}
</script>
